import React, { useState, useEffect } from 'react'
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

// ES6 Modules or TypeScript
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { CLEAR_EXAMINATION, CLEAR_EXAMINATION_DETAILS, CLEAR_MANAGEMENT_DETAILS, CLOSE_MODAL, OPEN_MODAL, SET_EDITED, SET_EXAMINATION_DETAILS, SET_MANAGEMENT_DETAILS, SET_MANAGEMENT_HISTORY, SET_PATIENT_DETAILS, SET_PERSONAL_REFERRAL_DETAILS } from '../../../redux/actions/types';
import { getCervixExaminationDetailsById, getUserDetails } from '../../../redux/actions/data.action';
import CustomModal from '../../../component/Modals/CustomModal';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import Calendar from 'react-calendar';
import TreatmentAppointment from '../../../component/Modals/TreatmentAppointmentModal';



const One = (props) => {
  const { managementDetails, treatmentDetails, patientDetails, personalReferralDetails, managementHistory } = useSelector(({ data }) => data);
  const {  examinationDetails, examination} = useSelector(({ examination }) => examination);
  const { viewOption, edited, modal } = useSelector(({ ui }) => ui)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [clinician, setClinician] = useState([]);
  const [validated, setValidated] = useState(false);
  const [monthSmear, setMonthSmear] = useState(0);


  const handleChanges = prop => event => {
    if (viewOption === 'review') {
      return console.log('REVIEW MODE')
    } 
    let formDetails = localStorage.getItem('formDetails');
    let frm = formDetails ? JSON.parse(formDetails) : {};


    let newVal = { ...managementDetails, [prop]: event.target.value === 'true' ? true : event.target.value === 'false' ? false : event.target.value }

    if (prop === 'ManagementPlan' && event.target.value === 'Treatment') {
      newVal = { ...newVal, TreatmentStatus: managementDetails.TreatmentStatus ? managementDetails.TreatmentStatus : "Not done" }
    }



    if (event.target.value === 'Smear') {
      dispatch({ type: OPEN_MODAL, payload: 'smear' })
      setMonthSmear(managementDetails.ManagementPlanMonthsToClinic)
    }



    dispatch({ type: SET_MANAGEMENT_DETAILS, payload: newVal })
    localStorage.setItem('formDetails', JSON.stringify({ ...frm, managementDetails: newVal }))
    dispatch({ type: SET_EDITED, payload: 'examination' })

    if (event.target.value === 'Treatment') {
      navigate(`${viewOption === "enter" ? "/dashboard/patient" : "/dashboard/viewPatient"}/treatment`)
    }
  }

  const handleBack = () => {
    navigate(-1)
  }

  const handleExit = (e) => {
    e.preventDefault();
  
    if (managementDetails.ManagementPlan === 'Smear' && !managementDetails.ManagementPlanMonthsToClinic) {
      dispatch({ type: OPEN_MODAL, payload: "smear" })
      return
    }



    if (edited.length !== 0) {
      dispatch({ type: OPEN_MODAL, payload: "save_details" })
      // return

    } else {
      dispatch({ type: CLEAR_EXAMINATION })
      dispatch({ type: CLEAR_EXAMINATION_DETAILS })
      dispatch({ type: CLEAR_MANAGEMENT_DETAILS })
    }


    navigate(`${viewOption === "enter" ? "/dashboard/patient" : "/dashboard/viewPatient"}`)

  }

  const handleLetter = () => {
    navigate(`/dashboard/letter-reports/generate`)
  }
  
  const handleDataSheet = () => {
    navigate(`/dashboard/generate-letter`, { state: { template: 'Data Sheet', letterType: 'Patient', SystemID: patientDetails.SystemID } })
  }



  const handleChangeClinician = (prop, e) => {

    if (viewOption === 'review') {
      return console.log('REVIEW MODE')
    }

    let selcted = clinician.find(a => a.iUserID == e.target.value)
    let formDetails = localStorage.getItem('formDetails');
    let frm = formDetails ? JSON.parse(formDetails) : {};

    if (selcted) {
      let { iUserID, Name } = selcted;
      dispatch({ type: SET_MANAGEMENT_DETAILS, payload: { ...managementDetails, [prop]: iUserID, treatementuser: Name } })
      localStorage.setItem('formDetails', JSON.stringify({ ...frm, managementDetails: { ...managementDetails, [prop]: iUserID, treatementuser: Name } }))


    } else {

      dispatch({ type: SET_MANAGEMENT_DETAILS, payload: { ...managementDetails, [prop]: null, treatementuser: null } })
      localStorage.setItem('formDetails', JSON.stringify({ ...frm, managementDetails: { ...managementDetails, [prop]: null, treatementuser: null } }))

    }
    dispatch({ type: SET_EDITED, payload: 'examination' })

  }


  const handleComments = prop => event => {
    let formDetails = localStorage.getItem('formDetails');
    let frm = formDetails ? JSON.parse(formDetails) : {};

    if (prop === 'ConsentNotes' || prop === 'MDTDecision') {
      let newVal = { ...examinationDetails, [prop]: event.target.value }

      dispatch({ type: SET_EXAMINATION_DETAILS, payload: newVal })
      localStorage.setItem('formDetails', JSON.stringify({ ...frm, examinationDetails: newVal }))
      dispatch({ type: SET_EDITED, payload: 'examination' })
    }

    if (prop === 'AdditionalInformation') {
      let newVal = { ...patientDetails, [prop]: event.target.value }
      dispatch({ type: SET_PATIENT_DETAILS, payload: newVal })
      localStorage.setItem('formDetails', JSON.stringify({ ...frm, patientDetails: newVal }))
      dispatch({ type: SET_EDITED, payload: 'personal' })
    }

    if (prop === 'provisionalplan') {
      let newVal = { ...personalReferralDetails, [prop]: event.target.value }
      dispatch({ type: SET_PERSONAL_REFERRAL_DETAILS, payload: newVal })
      localStorage.setItem('formDetails', JSON.stringify({ ...frm, personalReferralDetails: newVal }))
      dispatch({ type: SET_EDITED, payload: 'personal' })
    }
  }


  const handleGetClinics = () => {

    dispatch(getUserDetails({ Access: 2 }))
      .then(res => {

        if (res) {
          setClinician(res)
        }
      })

  }


  const handleGetExamination = (id) => {
    dispatch(getCervixExaminationDetailsById(id))
      .then(res => {
        let { tbl_CervixManagement, tbl_CervixManagementDetailsHistories } = res ? res : {};
      console.log(tbl_CervixManagementDetailsHistories,'EXAM RES')
        if(!examinationDetails.ExaminationID){
          dispatch({ type: SET_EXAMINATION_DETAILS, payload: res })
        }

        if (!managementDetails.ExaminationID && tbl_CervixManagement) {
          dispatch({ type: SET_MANAGEMENT_DETAILS, payload: tbl_CervixManagement })
          dispatch({ type: SET_MANAGEMENT_HISTORY, payload: tbl_CervixManagementDetailsHistories })
        }
      })
  }






  useEffect(() => {
    if (patientDetails && (patientDetails.NHSnumber || patientDetails.HospitalNumber)) {
      if ((examination && examination.ExaminationID)) {
        handleGetExamination(examination.ExaminationID)
      } 
    } else {
      navigate("/dashboard/home")
    }
  }, [examination, modal])

  useEffect(() => {
    handleGetClinics()
  }, [])


console.log(examination, examinationDetails, managementDetails,  'MANAGEMENT')

    const dischargeDate = (
      <div className='bordered'>
        <h3 className="card-title text-center bordered-title">Discharge Date</h3>
        <div className='form-group pl-2 pr-2'>
          <div className="text-left pl-5 pr-5" >
          <input
          type="date" id="MDMDate" name="MDMDate" className="form-control col-md-6" placeholder="MDM Date"
          value={managementDetails.MDMDate ? moment(managementDetails.MDMDate).format('YYYY-MM-DD') : ''}
          onChange={handleChanges('MDMDate')}
        />
            <div className='clr'></div> <br /><br />
          </div>
          <div className='bordered disabled'>
            <h3 className="card-title text-left bordered-title text-blue">Attendance Record</h3>
            <div className='row pl-3 pr-3'>
              <div className='col-md-3'>
                <input type="radio" value="1" name="styled_radio" required="" className="" />
                <label className="control-label text-end text-blue" >Scheduled</label>
                <div className='clr'></div>
              </div>
              <div className='col-md-3'>
                <input type="radio" value="1" name="styled_radio" required="" className="" />
                <label className="control-label text-end text-blue" >H cancel</label>
                <div className='clr'></div>
              </div>
              <div className='col-md-3'>
                <input type="radio" value="1" name="styled_radio" required="" className="" />
                <label className="control-label text-end text-blue" >P Cancel(99)</label>
                <div className='clr'></div>
              </div>
              <div className='col-md-3'>
                <input type="radio" value="1" name="styled_radio" required="" className="" />
                <label className="control-label text-end text-blue" >DNA(99)</label>
                <div className='clr'></div>
                <br />
              </div>
            </div>
            <div className="col-md-12 text-left" >
              <label className="control-label text-center col-md-3 text-blue" >Cancel Reason</label>
              <input type="text" id="firstName" className="form-control col-md-8 text-center" placeholder="" required />
              <div className='clr'></div>
            </div>
            <br />
          </div>
        </div>
      </div>
      
      
    )

  const nextAppointment = (
    <div className='bordered'>
      <h3 className="card-title text-center bordered-title">Next Appointment Date</h3>
      <div className='form-group pl-2 pr-2'>
        <div className="text-left pl-5 pr-5" >
          <label className="control-label text-center col-md-3 text-blue" >Date / Time</label>
          <input type="text" id="firstName" className="form-control col-md-8 text-center" placeholder="" required />
          <div className='clr'></div> <br /><br />
        </div>
        <div className='bordered'>
          <h3 className="card-title text-left bordered-title">Attendance Record</h3>
          <div className='row pl-3 pr-3'>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end text-blue" >Scheduled</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end text-blue" >H cancel</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end text-blue" >P Cancel(99)</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end text-blue" >DNA(99)</label>
              <div className='clr'></div>
              <br />
            </div>
          </div>
          <div className="col-md-12 text-left" >
            <label className="control-label text-center col-md-3 text-blue" >Cancel Reason</label>
            <input type="text" id="firstName" className="form-control col-md-8 text-center" placeholder="" required />
            <div className='clr'></div>
          </div>
          <br />
        </div>
      </div>
    </div>
  )


  const TreatmentAppointment = (
    <div className='bordered'>
      <h3 className="card-title text-center bordered-title">Treatment Appointment Date</h3>
      <div className='form-group pl-2 pr-2'>
        <div className="text-left pl-5 pr-5" >
          <label className="control-label text-center col-md-3" >Date / Time</label>
          <input type="date" id="TreatmentDate" className="form-control col-md-8 text-center" placeholder=""
            value={moment(managementDetails.TreatmentDate).format('YYYY-MM-DD')}
            onChange={handleChanges('TreatmentDate')}
          />
          <div className='clr'></div> <br /><br />
        </div>
        <div className='bordered'>
          <h3 className="card-title text-left bordered-title">Attendance Record</h3>
          <div className='row pl-3 pr-3'>
            <div className='col-md-3'>
              <input type="radio" 
              checked={managementDetails.TreatmentDate ? true : false }
              name="styled_radio" required="" className="" />
              <label className="control-label text-end" >Scheduled</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end" >H cancel</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end" >P Cancel</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end" >DNA</label>
              <div className='clr'></div>
              <br />
            </div>
          </div>
          <div className="col-md-12 text-left" >
            <label className="control-label text-center col-md-3" >Cancel Reason</label>
            <input type="text" id="firstName" className="form-control col-md-8 text-center" placeholder="" required />
            <div className='clr'></div>
          </div>
          <br />
        </div>
      </div>
    </div>
  )

  const smearAppointment = (
    <div className='bordered'>
      <h3 className="card-title text-center bordered-title">{managementDetails.ManagementPlanMonthsToClinic ? managementDetails.ManagementPlanMonthsToClinic : 0}-month Smear Appointment Date</h3>
      <div className='form-group pl-2 pr-2'>
        <div className="text-left pl-5 pr-5" >
          <label className="control-label text-center col-md-3 text-blue" >Date / Time</label>
          <input type="date" id="smearappointment" className="form-control col-md-8 text-center" placeholder=""
            value={managementDetails.ManagementPlanClinicDate ? moment(managementDetails.ManagementPlanClinicDate).format('YYYY-MM-DD') : ''}
            onChange={handleChanges('ManagementPlanClinicDate')}
          />
          <div className='clr'></div> <br />
        </div>
        <div className='bordered'>
          <h3 className="card-title text-left bordered-title text-blue">Attendance Record</h3>
          <div className='row pl-3 pr-3'>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end text-blue" >Scheduled</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" required="" className="" />
              <label className="control-label text-end text-blue" >H cancel</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" className="" />
              <label className="control-label text-end text-blue" >P Cancel(99)</label>
              <div className='clr'></div>
            </div>
            <div className='col-md-3'>
              <input type="radio" value="1" name="styled_radio" className="" />
              <label className="control-label text-end text-blue" >DNA(99)</label>
              <div className='clr'></div>
            </div>
          </div>
          <div className="col-md-12 text-left" >
            <label className="control-label text-center col-md-3 text-blue" >Cancel Reason</label>
            <input type="text" id="firstName" className="form-control col-md-8 text-center" placeholder="" required />
            <div className='clr'></div>
          </div>
          <br />
        </div>
      </div>
    </div>
  )




console.log(examinationDetails, managementDetails, managementHistory,'EXaM')
  let managementHistoryValue = '';
  
  managementHistory.forEach(a => {
    managementHistoryValue += a.sHistory +'\n';
  })
  
  return (
    <>
      <CustomModal
        size="lg"
        open={modal === 'smear'}
        title="Smear Details (0 in total)"
      /*      onOkay={() => {
               dispatch({ type: CLOSE_MODAL })
           }} */
      >
        <div className="bordered pb-2 " style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
          <h3 className="card-title bordered-title">Current Smear</h3>
          <div className="pl-3 pr-3" style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
            {/*   <input type="number" name="ManagementPlanMonthsToClinic" id="ManagementPlanMonthsToClinic" className="form-control col-md-2 mr-2"
              value={monthSmear}
              onChange={(e) => setMonthSmear(e.target.value)}
            /> */}
            <select name="ManagementPlanMonthsToClinic" id="ManagementPlanMonthsToClinic"
              className="form-control col-md-2 mr-2"
              value={monthSmear}
              onChange={(e) => setMonthSmear(e.target.value)}
            >
              <option value="0">0</option>
              {[3, 6, 9, 12, 24].map(a => {
                return (
                  <option value={a}>{a}</option>
                )
              })}
            </select>
            <input name="ConsentNotes" id="ConsentNotes" className=" form-control col-md-10" placeholder="" aria-invalid="false"
              value="-Month Smear"
            // onChange={handleComments('ConsentNotes')}
            />
          </div>
        </div>
        <div className="bordered pb-2 mt-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <h3 className="card-title bordered-title">Previous Smears</h3>
          <div className="pl-3 pr-3" style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
            <textarea name="AdditionalComments" id="AdditionalComments" className="form-control col-md-12" required="" placeholder="" aria-invalid="false"
              // value={examinationDetails.AdditionalComments}
              // onChange={handleComments('AdditionalComments')}
              rows="5"
            />
          </div>
        </div>
        <div className="pr-3 pl-3  mt-3">

          <Button className="float-right ml-2  btnIri" onClick={() => {
            dispatch({ type: CLOSE_MODAL })
            dispatch({ type: SET_MANAGEMENT_DETAILS, payload: { ...managementDetails, ManagementPlanMonthsToClinic: monthSmear } })
            dispatch({ type: SET_EDITED, payload: 'examination' })

          }}>Ok</Button>
          <Button className="float-right btn btn-light text-black" onClick={() => {
            dispatch({ type: CLOSE_MODAL })
          }}>Cancel</Button>
        </div>
      </CustomModal>
      <CustomModal
        size="lg"
        open={modal === 'ConsentNotes'}
        title="Additional Notes and Comments"
      /*      onOkay={() => {
               dispatch({ type: CLOSE_MODAL })
           }} */
      >
        <div className="bordered pb-2" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <h3 className="card-title bordered-title">Additional Comments</h3>
          <div>
            <div className="d-flex">
              <div className="col-md-6">
                <label className="text-left font-14 disabled" htmlFor="AdditionalComments">Additional Comments Examinations</label>
                <textarea name="AdditionalComments" disabled id="AdditionalComments" className="form-control " required="" placeholder="" aria-invalid="false"
                  value={examinationDetails.AdditionalComments}
                  onChange={handleComments('AdditionalComments')}
                  rows="3"
                />
              </div>
              <div className="col-md-6">
                <label className="text-left font-14" htmlFor="ConsentNotes">Consent Details</label>
                <textarea name="ConsentNotes" id="ConsentNotes" className="form-control" placeholder="" aria-invalid="false"
                  value={examinationDetails.ConsentNotes}
                  onChange={handleComments('ConsentNotes')}
                  rows="3"

                />
              </div>
            </div>
            <div className="d-flex mt-3">
              <div className="col-md-6">
                <label className="text-left font-14 disabled" htmlFor="TreatmentReason">Discussion</label>
                <textarea name="TreatmentReason" id="TreatmentReason" disabled className="form-control" placeholder="" aria-invalid="false"
                  value={treatmentDetails.TreatmentReason}
                  onChange={handleComments('TreatmentReason')}
                  rows="3"

                />
              </div>
              <div className="col-md-6">
                <label className="text-left font-14" htmlFor="AdditionalInformation">Any Other Additional Information</label>
                <textarea name="AdditionalInformation" id="AdditionalInformation" className="form-control" placeholder="" aria-invalid="false"
                  value={patientDetails.AdditionalInformation}
                  onChange={handleComments('AdditionalInformation')}
                  rows="3"

                />
              </div>
            </div>
            <div className="d-flex mt-3">
              <div className="col-md-12">
                <label className="text-left font-14" htmlFor="ProvisionalPlan">Provisional Plan</label>
                <textarea name="ProvisionalPlan" id="ProvisionalPlan" className="form-control w-100" placeholder="" aria-invalid="false"
                  value={personalReferralDetails.ProvisionalPlan}
                  onChange={handleComments('ProvisionalPlan')}
                  rows="2"

                />
              </div>
            </div>
            <div className="d-flex mt-3">
              <div className="col-md-12">
                <label className="text-left font-14" htmlFor="MDTDecision">MDT Decision</label>
                <textarea name="MDTDecision" id="MDTDecision" className="form-control" placeholder="" aria-invalid="false"
                  value={examinationDetails.MDTDecision}
                  onChange={handleComments('MDTDecision')}
                  rows="2"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="pr-3 pl-3">
          <Button className="float-right mt-3" onClick={() => {
            dispatch({ type: CLOSE_MODAL })
          }}>Exit</Button>
        </div>
      </CustomModal>
      
      <Form
        id="formValid"
        noValidate
        validated={validated}
        onSubmit={handleExit}
      >
        <div className="">
          <div className='pl-2 pr-2 text-left'>
            <div className='row bordered'>
              <h3 className='card-title text-center bordered-title'>Management Plan</h3>
              <div className="d-flex pl-2 pr-2">
                <div className='col-md-2 pl-4 mb-2 pl-2 pr-2 mt-3' >
                  <input
                    type="radio"
                    value="Await Decision"
                    id="Await Decision"
                    checked={managementDetails.ManagementPlan === 'Await Decision'}
                    name="managementplan_radio" className="" onChange={handleChanges('ManagementPlan')}
                  />
                  <label className=" text-blue" htmlFor='Await Decision' >Await Decision</label>
                  <div className='clearfix'></div>
                </div>
                <div className='col-md-4 text-left mb-3 pl-2 pr-2' >
                  <button type="button" className="btn btnIri marRight20 text-left"
                    onClick={() => dispatch({ type: OPEN_MODAL, payload: 'ConsentNotes' })}

                  >Provisional Plan</button>
                </div>

                <div className='col-md-6 text-right mb-2 pl-2 pr-2' >
                  <label className="col-md-2 text-left text-blue" >MDM Date</label>
                  <input
                    type="date" id="MDMDate" name="MDMDate" className="form-control col-md-6" placeholder="MDM Date"
                    value={managementDetails.MDMDate ? moment(managementDetails.MDMDate).format('YYYY-MM-DD') : ''}
                    onChange={handleChanges('MDMDate')}
                  />
                  <div className='clr'></div>
                </div>
              </div>
              <div className="col-md-6">
                <br />
                <div className="bordered pl-2 pr-2">
                  <h3 className="card-title txtLeft bordered-title">Treatment Plan</h3>
                  <br />
                  <div className='form-group d-flex pl-3 pr-3'>
                    <div className="col-md-4 pt-2">
                      <input type="radio"
                        value="Treatment"
                        id="Treatment"
                        checked={managementDetails.ManagementPlan === 'Treatment'}
                        name="managementplan_radio" className="" onChange={handleChanges('ManagementPlan')}
                        onClick={() => {
                          if (viewOption === 'review') {
                            return console.log('REVIEW MODE')
                          }
                          if (managementDetails.ManagementPlan === 'Treatment') {
                            navigate(`/dashboard/patient/treatment`)
                          }
                        }}
                      />
                      <label className="control-label text-end text-blue" htmlFor='Treatment' >Treatment</label>
                      <div className='clr'></div>
                    </div>
                    <div className="col-md-8 ">
                      <label className="col-md-4 text-blue" >Colposcopist</label>
                      <select name="TreatmentName" id="TreatmentName" className="col-md-8 form-control"
                        value={managementDetails.TreatmentName}
                        onChange={(e) => handleChangeClinician('TreatmentName', e)}
                      >
                        <option value="0">Select</option>
                        {clinician.length !== 0 && clinician.map(a => {
                          return (
                            <option value={a.iUserID}>{a.Name}</option>
                          )
                        })}
                      </select>
                      <div className='clr'></div>
                    </div>
                  </div>

                  <div className='form-group bordered d-flex pl-3 pr-3'>
                    <div className="col-md-4 padTop5">
                      <input type="radio"
                        value="Not done"
                        id="Not done"
                        checked={managementDetails.TreatmentStatus === 'Not done'}
                        name="treatmentstatus_radio" className="" onChange={handleChanges('TreatmentStatus')}
                      />
                      <label className="control-label text-end text-blue" htmlFor='Not done' >Not Done</label>
                      <div className='clr'></div>
                    </div>

                    <div className="col-md-4 padTop5">
                      <input type="radio"
                        value="Awaiting results"
                        id="Awaiting results"
                        checked={managementDetails.TreatmentStatus === 'Awaiting results'}
                        name="treatmentstatus_radio" className="" onChange={handleChanges('TreatmentStatus')}
                      />
                      <label className="control-label text-end text-blue" htmlFor='Awaiting results' >Awaiting Results</label>
                      <div className='clr'></div>
                    </div>

                    <div className="col-md-4 padTop5">
                      <input type="radio"
                        value="Completed"
                        id="Completed"
                        checked={managementDetails.TreatmentStatus === 'Completed'}
                        name="treatmentstatus_radio" className="" onChange={handleChanges('TreatmentStatus')}
                      />
                      <label className="control-label text-end text-blue" htmlFor='Completed'>Completed</label>
                      <div className='clr'></div>
                    </div>
                    <div className='clr'></div>
                  </div>
                </div>
                <br />
                <div className='clearfix'></div>
                <div className="bordered">
                  <h3 className="card-title txtLeft bordered-title">Post Colposcopy Smears</h3>
                  <br />
                  <div className='form-group d-flex pl-3 pr-3'>
                    <div className="col-md-2 padTop5">
                      <input type="radio"
                        value="Smear"
                        id="Smear"
                        checked={managementDetails.ManagementPlan === 'Smear'}
                        name="managementplan_radio" className="" onChange={handleChanges('ManagementPlan')}
                      />
                      <label className="control-label text-end text-blue" htmlFor='Smear' >Smear</label>
                      <div className='clr'></div>
                    </div>
                    <div className="col-md-5  text-left padTop5 mb-2" >
                      <label className="control-label col-md-5 text-left text-blue" >Months</label>
                      <input type="number" id="smearmonth" style={{ marginTop: -20 }} className="form-control col-md-5" placeholder="" required
                        value={managementDetails.ManagementPlanMonthsToClinic}
                        onClick={() => {
                          if (managementDetails.ManagementPlan !== 'Smear') return;
                          setMonthSmear(managementDetails.ManagementPlanMonthsToClinic)
                          dispatch({ type: OPEN_MODAL, payload: 'smear' })
                        }}
                      />
                      <div className='clr'></div>
                    </div>

                    <div className="col-md-2 padTop5 text-left mb-2">
                      <input type="checkbox" className="marRight10"
                        id="smear_taken" value={!managementDetails.SmearTaken} name="smear_taken"
                        checked={managementDetails.SmearTaken}
                        onChange={handleChanges('SmearTaken')}
                      />
                      <label className="control-label text-end text-blue" htmlFor="smear_taken" >Taken</label>
                      <div className='clr'></div>
                    </div>
                    <div className="col-md-3 padTop5 text-left mb-2">
                      <input type="checkbox" className="marRight10"
                        id="hpv_test" value={!managementDetails.HPVTest1} name="hpv_test"
                        checked={managementDetails.HPVTest1}
                        onChange={handleChanges('HPVTest1')}
                      />
                      <label className="control-label text-end text-blue" htmlFor="hpv_test">HPV Test</label>
                      <div className='clr'></div>
                    </div>

                  </div>


                  <div className='form-group d-flex pl-3 pr-3'>
                    <div className="col-md-4 padTop5 text-left mb-3">
                      <Button disabled={(managementDetails.ManagementPlan !== 'Smear' || managementDetails.ManagementPlanMonthsToClinic)} className="btn btnIri"
                        onClick={() => {
                          setMonthSmear(managementDetails.ManagementPlanMonthsToClinic)
                          dispatch({ type: OPEN_MODAL, payload: 'smear' })
                        }}
                      >New Smear</Button>
                      <div className='clr'></div>
                    </div>
                    <div className="col-md-8 padTop5 text-left">
                      <label className="control-label col-md-4 text-start text-blue" >Clinic</label>
                      <select name="PostSmearColposcopistName" id="PostSmearColposcopistName" className="col-md-8 form-control"
                        value={managementDetails.PostSmearColposcopistName}
                        onChange={(e) => handleChangeClinician('PostSmearColposcopistName', e)}
                      >
                        <option value="0">Select</option>
                        {clinician.length !== 0 && clinician.map(a => {
                          return (
                            <option value={a.iUserID}>{a.Name}</option>
                          )
                        })}
                      </select>
                      <div className='clr'></div>
                    </div>

                  </div>
                </div>
                <br />
                <div className="bordered">
                  <h3 className="card-title txtLeft bordered-title">Follow-up</h3>
                  <br />
                  <div className="form-group d-flex pl-3 pr-3">
                    <div className='col-md-4'>
                      <input type="radio" value="1" name="styled_radio" required="" className="" />
                      <label className="control-label text-end text-blue" >Gynaecology Clinic</label>
                      <div className='clr'></div>
                      <br />
                      <div className="" >
                        <input type="radio"  required="" 
                        checked={managementDetails.ManagementPlan === 'Colposcopy Clinic'}
                        name="managementplan_radio" className="" onChange={handleChanges('ManagementPlan')}
                        />
                        <label className="control-label text-end text-blue" >Colposcopy Clinic</label>
                        <div className='clr'></div>
                      </div>
                    </div>
                    <div className='col-md-8'>
                      <label className="control-label col-md-8 text-right text-blue" >Months</label>
                      <input type="text" id="firstName" style={{ marginTop: -20 }} className="form-control col-md-4 text-right" placeholder="" required />
                      <div className='clr'></div>
                      <br />
                      <div className="text-left" >
                        <label className="control-label text-right col-md-3 text-blue" >Clinic</label>
                        <input type="text" id="firstName" className="form-control col-md-9 text-left" placeholder="" required />
                        <div className='clr'></div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <br />
              </div>
              <div className="col-md-6">
                <br />
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <div className='bordered'>
                      <h3 className="card-title txtLeft bordered-title">Cancer Treatment</h3>
                      <div className='pt-1 pl-5 pr-3 pb-3'>
                        <input type="radio"
                          value="Cancer Treatment"
                          id="Cancer Treatment"
                          checked={managementDetails.ManagementPlan === 'Cancer Treatment'}
                          name="managementplan_radio" className="" onChange={handleChanges('ManagementPlan')}

                        />
                        <label className="control-label text-end text-blue" htmlFor="Cancer Treatment" >Cancer Treatment</label>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 mb-3'>
                    <div className='bordered'>
                      <h3 className="card-title txtLeft bordered-title">Other Treatment</h3>
                      <div className="pr-3 pl-3 pb-3">
                        <input type="text"
                          id="OtherTreatment" className="form-control " placeholder=""
                          value={managementDetails.OtherTreatment}
                          onChange={handleChanges('OtherTreatment')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row pr-2 pl-2'>
                  <div className='bordered mb-3 text-left'>
                    <h3 className="card-title bordered-title">Discharge</h3>
                    <div className="col-md-12 pl-3">
                      <input type="radio"
                        value="Discharge"
                        id="Discharge"
                        checked={managementDetails.ManagementPlan === 'Discharge'}
                        name="managementplan_radio" className="" onChange={handleChanges('ManagementPlan')}
                      />
                      <label className="control-label text-end text-blue" htmlFor='Discharge'>Discharge</label>
                      <div className='clr'></div>
                    </div>
                    <div className={`bordered pt-1 mb-2 ${managementDetails.ManagementPlan !== 'Discharge' && 'disabled'}`}>
                      <div className="pl-3">
                        <input disabled type="radio" value="1" name="styled_radio" required="" className="" />
                        <label className="control-label text-end text-blue" >Return to referrer</label>
                        <div className='clr'></div>
                      </div>
                      <div className="pl-3">
                        <input disabled type="radio" value="1" name="styled_radio" required="" className="" />
                        <label className="control-label text-end text-blue" >Never any evidence of disease</label>
                        <div className='clr'></div>
                      </div>
                      <div className="pl-3">
                        <input disabled type="radio" value="1" name="styled_radio" required="" className="" />
                        <label className="control-label text-end text-blue" >Disease reloved spontaneously</label>
                        <div className='clr'></div>
                      </div>
                      <div className="pl-3">
                        <input disabled type="radio" value="1" name="styled_radio" required="" className="" />
                        <label className="control-label text-end text-blue" >Completed procedures</label>
                        <div className='clr'></div>
                      </div>
                      <div className="pl-3">
                        <input disabled type="radio" value="1" name="styled_radio" required="" className="" />
                        <label className="control-label text-end text-blue" >Failure to attend</label>
                        <div className='clr'></div>
                      </div>
                      <div className="pl-3">
                        <input disabled type="radio" value="1" name="styled_radio" required="" className="" />
                        <label className="control-label text-end text-blue" >Follow-up / Treatment elsewhere</label>
                        <div className='clr'></div>
                      </div>
                    </div>
                    <div className='col-md-12 text-right' >
                      <label className="col-md-4 text-center text-blue" >Comments</label>
                      <input type="text" id="firstName" className="form-control col-md-8" placeholder="" required />
                      <div className='clr'></div><br />
                    </div>
                    <div className='col-md-12 text-right' >
                      <label className="col-md-4 text-center text-blue" >Outcome</label>
                      <input disabled type="text" id="firstName" className="form-control col-md-8" placeholder="" required />
                      <div className='clr'></div>
                    </div>
                    <br />
                  </div>

                  <div className='clearfix'></div>

                  <div className='bordered'>
                    <h3 className="card-title txtLeft bordered-title">History</h3>
                    <div className="col-md-12 pb-3">
                      <textarea rows="3" value={managementHistoryValue}  name="textarea" id="textarea" className="form-control" required="" placeholder="" aria-invalid="false" />
                    </div>
                  </div>
                </div>
                <br />
              </div>



            </div>
          </div>

          <br />
          <div className='pl-2 pr-2'>
            <div className='row text-left'>
              <div className='col-md-6 mb-4'>
                {managementDetails.ManagementPlan === 'Discharge' ? dischargeDate : managementDetails.ManagementPlan === 'Treatment' ? TreatmentAppointment : managementDetails.ManagementPlan === 'Smear' ? smearAppointment : nextAppointment}

              </div>
              <div className='col-md-6'>
                <div className='row' style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                  <div className='col-md-8 text-left mb-4'>
                    <Button className="btn text-dark btn-secondary mr-2" disabled>Re-instate</Button>
                    <Button className="btn text-dark btn-secondary mr-2" onClick={() => handleDataSheet() }>Data Sheet</Button>
                    <Button className="btn text-dark btn-secondary mr-2" onClick={() => handleLetter()}>Letter</Button>
                  </div>
                  <div className='col-md-4 mb-4 text-right' style={{ justifyContent: 'space-between' }}>
                    <Button className="btn btnIri mr-2" onClick={() => handleBack()}>Previous</Button>
                    <Button className="btn btnIri" type="submit" >Exit</Button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Form >
      
    </>

  );


}

const Management = () => {
  const navigate = useNavigate();
  const { patientDetails } = useSelector(({ data }) => data)

  
  useEffect(() => {
      if (patientDetails && (patientDetails.NHSnumber || patientDetails.HospitalNumber)) {
          //   setPatient(patientDetails)
      } else {
          navigate('/dashboard/home');
      }
  }, [patientDetails, navigate]);





  return (
    <>


      <div className="card-header bg-iri txtLeft">
        <h4 className="text-white">Patient Management Details</h4>
      </div>



      <div className="card-body">
      <One />
            </div>
    </>
  );
}

export default Management;
